import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'toggle', 'count', 'submit']

  connect () {
    this.sync()
  }

  toggleAll (event) {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = event.currentTarget.checked
    })
    this.sync()
  }

  sync () {
    const selectedCount = this.checkboxTargets.filter((checkbox) => checkbox.checked).length

    if (this.hasCountTarget) {
      this.countTarget.textContent = selectedCount
    }
    this.submitTargets.forEach((submit) => {
      submit.disabled = selectedCount === 0
    })
    if (this.hasToggleTarget) {
      this.toggleTarget.checked = selectedCount > 0 && selectedCount === this.checkboxTargets.length
      this.toggleTarget.indeterminate = selectedCount > 0 && selectedCount < this.checkboxTargets.length
    }
  }
}
